import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {WriteReportForm} from "@/pages/Report/WriteReport";
import {SearchBO} from "@/service/common.s";
import {PlanPO, ReportPO, ReviewPO, TaskPO} from "@/model/mission";

export enum ReportEnum {
    GetReportPage = "/report/getReportPage",
    GetReport = "/report/getReport",
    CreateReport = "/report/createReport",
    SearchReport = "/report/searchReport",
    GetAllReport = "/report/getAllReport",
}

export interface ReportPageBO {
    keyword?: string;
}

export interface SearchReportVO extends ReportPO {
    names: string;
}

export interface ReportPageVO extends ReportPO {
    planName: string;
    executor: string;
    executorId: number
    virtue: string;
    priority: string;
    taskName: string;
    reviewerId: number;
    status: number;
    virtueId: number
    priorityId: number
}

export interface ReportVO extends ReportPO {
    task: TaskPO
    plan: PlanPO
    review: ReviewPO
}

export const useQueryReportPage = () => useMutation<BaseVO<PaginationVO<ReportPageVO>>, null, ReportPageBO>({
    mutationFn: (data: ReportPageBO) => http.post<BaseVO<PaginationVO<ReportPageVO>>>({
        url: ReportEnum.GetReportPage,
        data: data,
    }),
})

export const useQueryReport = (params: GetByIdBO, enabled: boolean) => useQuery<BaseVO<ReportVO>>({
    queryKey: [params.id], enabled, queryFn: () => http.get<BaseVO<ReportVO>>({
        url: ReportEnum.GetReport,
        params: params
    })
})

export const useCreateReport = () => useMutation({
    mutationFn: (data: WriteReportForm) => http.put<BaseVO<null>>({url: ReportEnum.CreateReport, data}),
})


